import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

import { OrderStatuses, setCacheOrderAtom } from "../atoms/cacheOrders";

export const getPoizonTraceOrder = reatomAsync(
  (_ctx, clientId: string, orderNo: string) => {
    return API.poizonPublicApi
      .dewuControllerTraceOrder(clientId, orderNo)
      .then((d) => d.data);
  },
  "getPoizonTraceOrder",
).pipe(withDataAtom(null));

export const getPoizonTraceOrderWithCache = reatomAsync(
  (ctx, clientId: string, orderNo: string) => {
    return API.poizonPublicApi
      .dewuControllerTraceOrder(clientId, orderNo)
      .then((d) => {
        const data = d.data;
        const list = data.dispatchList;
        if (list.length == 0) {
          setCacheOrderAtom(ctx, {
            orderNo,
            status: OrderStatuses.unknown,
          });
          return d.data;
        }
        const lastStep = list[0].logistics[0];
        setCacheOrderAtom(ctx, {
          orderNo,
          status: lastStep ? OrderStatuses.done : OrderStatuses.inTransit,
          trackNo: list[0]?.number,
        });
        return d.data;
      });
  },
  "getPoizonTraceOrderWithCache",
).pipe(withDataAtom(null), withIsLoadingAtom());
